import React from 'react';
import { Col, Row } from 'react-bootstrap-5';
import EmptyState from 'shared/empty_state';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { NonBasicCardStyling } from './util';

type SyndicationPartner = {
  banner: string,
  id: number,
  order: number,
  partner_name: string
}
export type Props = {
  syndicationPartners: SyndicationPartner[]
}

export default function SyndicationCard({ syndicationPartners }: Props) {
  function contentForCard() {
    return (
      <>
        <div className="ds-text-muted">Published on the Buildout Syndication Network, including these channels:</div>
        <Row className="g-3">
          {syndicationPartners.map((syndicationPartner, index) => (
            <Col key={syndicationPartner.id} md={6}>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: '80px', padding: '10px' }}
              >
                <img
                  alt={syndicationPartner.partner_name}
                  className="img-fluid"
                  src={syndicationPartner.banner}
                  style={{
                    filter: 'grayscale(1)',
                    maxHeight: '100%',
                    maxWidth: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
            </Col>
          ))}
        </Row>
      </>
    );
  }

  return (
    <div className={NonBasicCardStyling}>
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-normal">Syndication</h6>
      </div>
      {syndicationPartners.length > 0 ? contentForCard() : (
        <EmptyState
          bodyText="Waiting For Data..."
          header="No Syndication data to display"
          icon={faExclamationCircle}
          style={{ minHeight: '250px' }}
        />
      )}
    </div>
  );
}
